<div class="page-heading modal-content-header">
    <h1 class="layer-title">Supprimer la facture <b>{{billing.invoiceNumber? (" n°"+billing.invoiceNumber): ""}}</b></h1>
</div>

<div class="modal-content-body">
    <div class="row">
        <div class="col-sm-12">
            Vous souhaitez supprimer un facture prévue le <b>{{billing.plannedDate?.toLocaleDateString()}}</b> d'un montant de <b>{{billing.amountExclTax}}</b> € HT.
        </div>
    </div>
    @if(billing.isSent){
        <div class="row">
            <div class="col-sm-12">
                <b>Cette facture a pourtant déjà été émise !!</b>
            </div>
        </div>
    }
    <div class="row">
        <div class="col-sm-12">
            <b> Cette action est définitive</b> 
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <ed-checkbox
                id="updateSubcontractingAmount"
                [(checked)]="updateSubcontractingAmount">
            </ed-checkbox>
            <label> Mettre à jour le montant total du projet ( {{getDiff()}} €HT ) </label>
        </div>
    </div>  
</div>
<div class="layer-actions">
    <ed-button [colorSchema]="buttonColors.Secondary" (click)="close()">Retour</ed-button>
    <ed-button (click)="valid()" >Supprimer</ed-button>
</div>